import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';

/**
 * Delete a single user by its External ID
 * @param externalId External ID of the User to delete
 * @returns A data object to indicate success
 */
export function deleteUsersExternalId(this: unknown, externalId: string) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).usersUrl}/${encodeURIComponent(
          externalId
        )}`,
        {
          method: 'DELETE',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.object({
          success: z.boolean(),
        }),
      })
    )
  );
}
